/**
 * Dashboard tiles -> Incidents list presets. Each preset is a status toggle ("Open" = anything
 * not Closed) plus extra server filters, matching how the dashboard counts them.
 */
export const INCIDENT_PRESETS = {
  active: { label: "Active incidents", toggle: "Open", filters: {} },
  closed: { label: "Closed incidents", toggle: "Closed", filters: {} },
  emergencies: { label: "Active emergencies", toggle: "Open", filters: { emergency: ["True"] } },
  escalations: { label: "Active escalations", toggle: "Open", filters: { escalated: ["True"] } },
};

/** Build DataTableMD starting props from navigation state ({ preset, district, school }). */
export const presetFromState = (state) => {
  const preset = state && INCIDENT_PRESETS[state.preset];
  if (!preset) return null;
  const filters = { ...preset.filters, status: [preset.toggle] };
  if (state.district) filters.district = [state.district];
  if (state.school) filters.school = [state.school];
  return { label: preset.label, toggle: preset.toggle, filters };
};
